'use client'

import { styled } from 'styled-components'

import {
  ButtonAsA,
  FormattedMessage,
  Link,
} from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

import { LINKS } from './content'
import { Inner, Section } from './ui'
import { useAuthCtaTracking } from './useAuthCtaTracking'

const BandInner = styled(Inner)`
  gap: 1.5rem;

  @media ${Breakpoints.min.large} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 3rem;
  }
`

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Title = styled.h2`
  ${Typography.Title2};
  margin: 0;
  color: ${Colors.Semantic.Neutral.white};
`

const Body = styled.p`
  ${Typography.Body1};
  margin: 0;
  text-wrap: pretty;
  color: ${Colors.Semantic.Neutral.white};
`

const Actions = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.5rem;
`

const WhiteButton = styled(ButtonAsA)`
  background-color: ${Colors.Semantic.Neutral.white};
  color: ${Colors.Semantic.BStock.default.lightBackground};

  &&:hover,
  &&:active {
    background-color: ${Colors.Semantic.Neutral.light_grey};
    color: ${Colors.Semantic.BStock.default.lightBackground};
  }
`

const SignIn = styled(Link)`
  ${Typography.Body1_Semibold};
  white-space: nowrap;

  &&,
  &&:hover,
  &&:active {
    color: ${Colors.Semantic.Neutral.white};
  }
`

export default function CtaBand() {
  const { onCreateAccount, onSignIn } = useAuthCtaTracking('homepage_cta_band')

  return (
    <Section
      $background={Colors.Semantic.BStock.default.lightBackground}
      data-testid="logged-out-cta-band"
    >
      <BandInner>
        <Copy>
          <Title>
            <FormattedMessage id="LoggedOutHomepage.ctaBand.title" />
          </Title>
          <Body>
            <FormattedMessage id="LoggedOutHomepage.ctaBand.body" />
          </Body>
        </Copy>
        <Actions>
          <WhiteButton
            appearance="primary"
            size="large"
            href={LINKS.signup}
            onClick={onCreateAccount}
          >
            <FormattedMessage id="LoggedOutHomepage.ctaBand.createAccount" />
          </WhiteButton>
          <SignIn href={LINKS.signin} onClick={onSignIn}>
            <FormattedMessage id="LoggedOutHomepage.ctaBand.signIn" />
          </SignIn>
        </Actions>
      </BandInner>
    </Section>
  )
}
